// import Config from "../Custom/config";
// eslint-disable-next-line no-use-before-define
var Config = config();// eslint-disable-line

export function isdigit(e) {
    return /^\d*\.?\d*$/.test(e);
}
export function isBetween(e, min, max) {
    const regex = new RegExp(`^\\d*\\.?\\d*$`);
    return regex.test(e) && parseFloat(e) >= min && parseFloat(e) <= max;
}

export function signOut() {
    localStorage.clear();
    window.location.href = process.env.PUBLIC_URL + "/Login";
}

var lastSnackbars = [];
export function toast(message, time = 3000, parent) {
    var mb = 0;
    if (lastSnackbars.length) mb = lastSnackbars.length * 80;
    var snackbar = document.createElement("div");
    var random = Math.random().toString(36).substring(7);
    snackbar.setAttribute("id", "snackbar_" + random);
    snackbar.classList.add("snackbar");

    (parent || document.body).appendChild(snackbar);

    //snackbar.className = "show";
    snackbar.style.cssText = `visibility: visible;
            -webkit-animation: fadein 0.5s, fadeout 0.5s ${time - 500}ms;
            animation: fadein 0.5s, fadeout 0.5s ${time - 500}ms;
            margin-top: ${mb}px`;
    snackbar.innerHTML = message;

    snackbar.addEventListener("click", () => {
        snackbar.remove();
        lastSnackbars = lastSnackbars.filter(function (item) {
            return item.id !== snackbar.id;
        });
        lastSnackbars.forEach((el) => {
            el.style.marginTop = parseInt(el.style.marginTop) - 80 + "px";
        });
        snackbar = null;
    });

    setTimeout(() => {
        if (snackbar) {
            lastSnackbars.forEach((el) => {
                el.style.marginTop = parseInt(el.style.marginTop) - 80 + "px";
            });
        }
    }, time - 500);
    setTimeout(function () {
        if (snackbar) {
            snackbar.style.cssText = "";
            setTimeout(() => {
                snackbar.remove();
                lastSnackbars = lastSnackbars.filter(function (item) {
                    return item.id !== snackbar.id;
                });
            }, 500);
        }
    }, time - 100);
    // const initial = parseInt(getComputedStyle(snackbar).bottom);
    // window.addEventListener("resize", () => {
    //             const keyboardHeight = window.outerHeight - window.innerHeight;
    //             if(snackbar.style.visibility != "hidden"){
    //                 snackbar.style.bottom = keyboardHeight + initial + "px";
    //             }
    // });
    lastSnackbars.push(snackbar);
}

export function modalAlert(message, title, options) {
    //fazel
    // if (typeof enableControls == "function") {
    //     enableControls();
    // }
    //-fazel
    if (message && typeof message === "string")
        while (message.includes("\r\n"))
            message = message.replace("\r\n", "<br/>");
    if (typeof options != "object") {
        options = {};
    }
    if (options.delay != undefined) {
        options.delay++;
        options.delay--;
    } else {
        options.delay = 100;
    }
    if (!window.smile_alert) {
        var smile_obj = {
            selecter: "smile-modalAlert",
            element: null,
            filter: 30,
            cancelElement: null,
            confirmElement: null,
        };
        smile_obj.element = document.querySelector(smile_obj.selecter);
    } else {
        if (window.smile_alert.cancel) {
            window.smile_alert.cancelElement.style = "";
        }
        if (window.smile_alert.confirm) {
            window.smile_alert.confirmElement.style = "";
        }
        window.smile_alert.element.style.display = "block";
        smile_obj = window.smile_alert;
    }
    // document.querySelector("#dvContent").style.filter = "blur(2px)";
    // document.querySelector(".header").style.filter = "blur(2px)";
    smile_obj.cancel = options.cancel != undefined ? options.cancel : false;
    smile_obj.cancelText =
        options.cancelText != undefined ? options.cancelText : "انصراف";
    smile_obj.cancelCallBack = function (event) {
        window.smile_alert.cancelElement.style =
            "background-color:#999;color:#000;filter:alpha(opacity=" +
            window.smile_alert.filter +
            ");-moz-opacity:" +
            window.smile_alert.filter / 100 +
            ";-khtml-opacity: " +
            window.smile_alert.filter / 100 +
            ";opacity: " +
            window.smile_alert.filter / 100 +
            ";";
        setTimeout(function () {
            window.smile_alert.element.style.display = "none";
            if (typeof options.cancelCallBack == "function") {
                options.cancelCallBack(event);
            }
            return true;
        }, window.smile_alert.delay);
        // document.querySelector("#dvContent").style.filter = "none";
        // document.querySelector(".header").style.filter = "none";
        //console.log('concel');
    };
    smile_obj.closeCallBack = function () {
        window.smile_alert.cancelElement.style =
            "background-color:#999;color:#000;filter:alpha(opacity=" +
            window.smile_alert.filter +
            ");-moz-opacity:" +
            window.smile_alert.filter / 100 +
            ";-khtml-opacity: " +
            window.smile_alert.filter / 100 +
            ";opacity: " +
            window.smile_alert.filter / 100 +
            ";";
        setTimeout(function () {
            window.smile_alert.element.style.display = "none";
            return true;
        }, window.smile_alert.delay);
        // document.querySelector("#dvContent").style.filter = "none";
        // document.querySelector(".header").style.filter = "none";
        //console.log('concel');
    };
    smile_obj.message = message;
    smile_obj.title = title;
    smile_obj.confirm = options.confirm != undefined ? options.confirm : true;
    smile_obj.confirmText =
        options.confirmText != undefined ? options.confirmText : "متوجه شدم";
    smile_obj.confirmCallBack = function (event) {
        window.smile_alert.confirmElement.style =
            "background-color:#999;color:#04BE02;filter:alpha(opacity=" +
            window.smile_alert.filter +
            ");-moz-opacity:" +
            window.smile_alert.filter / 100 +
            ";-khtml-opacity: " +
            window.smile_alert.filter / 100 +
            ";opacity: " +
            window.smile_alert.filter / 100 +
            ";";
        setTimeout(function () {
            window.smile_alert.element.style.display = "none";
            if (typeof options.confirmCallBack == "function") {
                options.confirmCallBack(event);
            }
            return true;
        }, window.smile_alert.delay);
        // document.querySelector("#dvContent").style.filter = "none";
        // document.querySelector(".header").style.filter = "none";
        //console.log('confirm');
    };
    if (!smile_obj.element) {
        smile_obj.html =
            '<div class="' +
            smile_obj.selecter +
            '" id="' +
            smile_obj.selecter +
            '">' +
            '<div class="' +
            smile_obj.selecter +
            '-mask"></div>' +
            '<div class="' +
            smile_obj.selecter +
            '-message-body">' +
            '<button class="' +
            smile_obj.selecter +
            '-message-button-close"><span>×</span ></button >' +
            '<div class="' +
            smile_obj.selecter +
            "-message-tbf " +
            smile_obj.selecter +
            '-message-title"><strong class="' +
            smile_obj.selecter +
            '-message-tbf ">' +
            smile_obj.title +
            "</strong></div>" +
            '<div class="' +
            smile_obj.selecter +
            "-message-tbf " +
            smile_obj.selecter +
            '-message-content">' +
            smile_obj.message +
            "</div>" +
            '<div class="' +
            smile_obj.selecter +
            "-message-tbf " +
            smile_obj.selecter +
            '-message-button">';
        if (smile_obj.cancel || true) {
            smile_obj.html +=
                '<a href="javascript:;" class="' +
                smile_obj.selecter +
                "-message-tbf " +
                smile_obj.selecter +
                '-message-button-cancel">' +
                smile_obj.cancelText +
                "</a>";
        }
        if (smile_obj.confirm || true) {
            smile_obj.html +=
                '<a href="javascript:;" class="' +
                smile_obj.selecter +
                "-message-tbf " +
                smile_obj.selecter +
                '-message-button-confirm">' +
                smile_obj.confirmText +
                "</a>";
        }
        smile_obj.html += "</div>" + "</div>" + "</div>";
        var element = document.createElement("div");
        element.id = smile_obj.selecter + "-wrap";
        element.innerHTML = smile_obj.html;
        document.body.appendChild(element);
        smile_obj.element = document.querySelector("." + smile_obj.selecter);
        smile_obj.cancelElement = document.querySelector(
            "." + smile_obj.selecter + "-message-button-cancel"
        );
        smile_obj.closeButton = document.querySelector(
            "." + smile_obj.selecter + "-message-button-close"
        );
        if (smile_obj.cancel) {
            document.querySelector(
                "." + smile_obj.selecter + "-message-button-cancel"
            ).style.display = "block";
        } else {
            document.querySelector(
                "." + smile_obj.selecter + "-message-button-cancel"
            ).style.display = "none";
        }
        smile_obj.confirmElement = document.querySelector(
            "." + smile_obj.selecter + "-message-button-confirm"
        );
        if (smile_obj.confirm) {
            document.querySelector(
                "." + smile_obj.selecter + "-message-button-confirm"
            ).style.display = "block";
        } else {
            document.querySelector(
                "." + smile_obj.selecter + "-message-button-confirm"
            ).style.display = "none";
        }
        smile_obj.cancelElement.onclick = smile_obj.cancelCallBack;
        if (!options.close) smile_obj.closeButton.display = "none";
        else smile_obj.closeButton.onclick = smile_obj.closeCallBack;
        smile_obj.confirmElement.onclick = smile_obj.confirmCallBack;
        window.smile_alert = smile_obj;
        //console.log(smile_alert);
    }
    document.querySelector(
        "." + smile_obj.selecter + "-message-title"
    ).innerHTML = "";
    document.querySelector(
        "." + smile_obj.selecter + "-message-content"
    ).innerHTML = "";
    document.querySelector(
        "." + smile_obj.selecter + "-message-button-cancel"
    ).innerHTML = smile_obj.cancelText;
    document.querySelector(
        "." + smile_obj.selecter + "-message-button-confirm"
    ).innerHTML = smile_obj.confirmText;
    smile_obj.cancelElement = document.querySelector(
        "." + smile_obj.selecter + "-message-button-cancel"
    );
    smile_obj.closeButton = document.querySelector(
        "." + smile_obj.selecter + "-message-button-close"
    );
    if (smile_obj.cancel) {
        document.querySelector(
            "." + smile_obj.selecter + "-message-button-cancel"
        ).style.display = "block";
    } else {
        document.querySelector(
            "." + smile_obj.selecter + "-message-button-cancel"
        ).style.display = "none";
    }
    smile_obj.confirmElement = document.querySelector(
        "." + smile_obj.selecter + "-message-button-confirm"
    );
    if (smile_obj.confirm) {
        document.querySelector(
            "." + smile_obj.selecter + "-message-button-confirm"
        ).style.display = "block";
    } else {
        document.querySelector(
            "." + smile_obj.selecter + "-message-button-confirm"
        ).style.display = "none";
    }
    smile_obj.cancelElement.onclick = smile_obj.cancelCallBack;

    if (!options.close) smile_obj.closeButton.style.display = "none";
    else smile_obj.closeButton.onclick = smile_obj.closeCallBack;
    smile_obj.confirmElement.onclick = smile_obj.confirmCallBack;
    if (smile_obj.title && smile_obj.message) {
        document.querySelector(
            "." + smile_obj.selecter + "-message-title"
        ).innerHTML = smile_obj.title;
        if (
            message &&
            (message instanceof Element || message instanceof HTMLDocument)
        )
            document
                .querySelector("." + smile_obj.selecter + "-message-content")
                .appendChild(smile_obj.message);
        else
            document.querySelector(
                "." + smile_obj.selecter + "-message-content"
            ).innerHTML = smile_obj.message;
    } else if (smile_obj.message) {
        if (
            message &&
            (message instanceof Element || message instanceof HTMLDocument)
        )
            document
                .querySelector("." + smile_obj.selecter + "-message-content")
                .appendChild(smile_obj.message);
        else
            document.querySelector(
                "." + smile_obj.selecter + "-message-content"
            ).innerHTML = smile_obj.message;
    } else if (smile_obj.title) {
        document.querySelector(
            "." + smile_obj.selecter + "-message-title"
        ).innerHTML = smile_obj.title;
    }
    window.smile_alert = smile_obj;
}


export function handleKeyDown(event, element, type) {
    if ((event.key === "Enter" || event.keyCode === 13 || event.which === 13) && 
    (!event.shiftKey)) {   
        if (type == "textarea") {
            element.current.querySelector("textarea").focus();
        } else if (type == "input") {
            element.current.querySelector("input").focus();
        } else if (type == "Date") {
        
            element.current.querySelector("input").focus();
        }else if(type == "btn"){
            event.preventDefault();
            element.current.click();
        }
    }
}
export function ApiServices(url, body = null, method) {
    const totalUrl = `${Config.RootAddress}${url}`;
    const bodyDate = JSON.stringify(body || {});
    var myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("Ticket")
    );
    return fetch(totalUrl, {
        method: method,
        mode: "cors",
        cache: "no-cache",
        credentials: "omit",
        redirect: "follow",
        referrer: "no-referrer",
        headers: myHeaders,
        body: method.toLowerCase() == "get" ? null : bodyDate,
    });
}
export function CallService(
    servicesUrl,
    obj,
    method,
    setIsLoading,
    hasLoading = false
) {
    hasLoading === true ? setIsLoading(true) : setIsLoading(false);
    return ApiServices(servicesUrl, obj, method)
        .then( async (response) => {
            setIsLoading(false);
            var responseText = "";
            try {
                responseText = await response.text();
            } catch {
                responseText = "";
            }
            if (response.ok) {
                return responseText;
            } else {
                return Promise.reject(responseText);
            }
        })
        .then((data) => {
            try {
                data = JSON.parse(data);
            } catch {}
            return data;
        });
}


String.prototype.toPersianUniCode = function (removeSpaces = true) {

    var ret = this;
    if (removeSpaces) ret = ret.replaceAll(" ", "");

    return ret
        .replaceAll("ی", "ي")
        .replaceAll("آ", "ا")
        .replaceAll("ۀ", "ه")
        .replaceAll("ة", "ه")
        .replaceAll("ؤ", "و")
        .replaceAll("إ", "ا")
        .replaceAll("أ", "ا")
        .replaceAll("ء", "و")
        .replaceAll("ك", "ک")
        .replaceAll("ڪ", "ک")
        .replaceAll("الله", "اله")
        .replaceAll("ا...", "اله");
};

var dkSolar = 0;
var dkGregorian = 1;
function IsLeapYear(DateKind, Year) {
    if (DateKind == dkSolar) return ((Year + 38) * 31) % 128 <= 30;
    else return Year % 4 == 0 && (Year % 100 != 0 || Year % 400 == 0);
}
var GREGORIAN_EPOCH = 1721425.5;
var PERSIAN_EPOCH = 1948320.5;
function mod(a, b) {
    return a - b * Math.floor(a / b);
}
function persian_to_jd(year, month, day) {
    var epbase, epyear;

    epbase = year - (year >= 0 ? 474 : 473);
    epyear = 474 + mod(epbase, 2820);
    return (
        day +
        (month <= 7 ? (month - 1) * 31 : (month - 1) * 30 + 6) +
        Math.floor((epyear * 682 - 110) / 2816) +
        (epyear - 1) * 365 +
        Math.floor(epbase / 2820) * 1029983 +
        (PERSIAN_EPOCH - 1)
    );
}
function gregorian_to_jd(year, month, day) {
    return (
        GREGORIAN_EPOCH -
        1 +
        365 * (year - 1) +
        Math.floor((year - 1) / 4) +
        -Math.floor((year - 1) / 100) +
        Math.floor((year - 1) / 400) +
        Math.floor(
            (367 * month - 362) / 12 +
                (month <= 2 ? 0 : IsLeapYear(dkGregorian, year) ? -1 : -2) +
                day
        )
    );
}
function jd_to_persian(jd) {
    var year, month, day, depoch, cycle, cyear, ycycle, aux1, aux2, yday;

    jd = Math.floor(jd) + 0.5;

    depoch = jd - persian_to_jd(475, 1, 1);
    cycle = Math.floor(depoch / 1029983);
    cyear = mod(depoch, 1029983);
    if (cyear == 1029982) {
        ycycle = 2820;
    } else {
        aux1 = Math.floor(cyear / 366);
        aux2 = mod(cyear, 366);
        ycycle =
            Math.floor((2134 * aux1 + 2816 * aux2 + 2815) / 1028522) + aux1 + 1;
    }
    year = ycycle + 2820 * cycle + 474;
    if (year <= 0) {
        year--;
    }
    yday = jd - persian_to_jd(year, 1, 1) + 1;
    month = yday <= 186 ? Math.ceil(yday / 31) : Math.ceil((yday - 6) / 30);
    day = jd - persian_to_jd(year, month, 1) + 1;
    return new Array(year, month, day);
}
function GregorianToSolar(gYear, gMonth, gDay) {
    if (gDay == 0 && gMonth == 0 && gYear == 0) {
        var dDate = new Date();
        gDay = dDate.getDate();
        gMonth = dDate.getMonth() + 1;
        gYear = dDate.getFullYear();
    }
    var _jd = gregorian_to_jd(gYear, gMonth, gDay);
    var persianDate = jd_to_persian(_jd);
    this.gYear = persianDate[0];
    this.gMonth = parseInt(persianDate[1]) - 1;
    this.gDay = persianDate[2];
    this.getDate = function () {
        return this.gDay;
    };
    this.getMonth = function () {
        return this.gMonth;
    };
    this.getYear = function () {
        return this.gYear;
    };
    this.getFullYear = function () {
        return this.gYear;
    };
}
function SolarToGregorian(sYear, sMonth, sDay) {
    if (sDay === 0 && sMonth === 0 && sYear === 0) {
        var dDate = new Date();
        return dDate;
    }
    //'******************* Leap year
    if (sYear === 1378) {
        if (sMonth === 12 && sDay === 10) {
            sYear = 2000;
            sMonth = 2;
            sDay = 29;
            return;
        }

        if (sMonth === 12 && sDay > 10) sDay--;
    } else if (sYear === 1379) {
        sDay--;

        if (sDay === 0) {
            sMonth--;
            if (sMonth > 0 && sMonth < 7) sDay = 31;
            if (sMonth > 6) sDay = 30;
            if (sMonth === 0) {
                sDay = 29;
                sMonth = 12;
                sYear--;
            }
        }
    }
    //'*******************
    if (sMonth < 10 || (sMonth === 10 && sDay < 11)) sYear += 621;
    else sYear += 622;

    switch (sMonth) {
        case 1:
            if (sDay < 12) {
                sMonth = 3;
                sDay += 20;
            } else {
                sMonth = 4;
                sDay -= 11;
            }
            break;
        case 2:
            if (sDay < 11) {
                sMonth = 4;
                sDay += 20;
            } else {
                sMonth = 5;
                sDay -= 10;
            }
            break;
        case 3:
            if (sDay < 11) {
                sMonth = 5;
                sDay += 21;
            } else {
                sMonth = 6;
                sDay -= 10;
            }
            break;
        case 4:
            if (sDay < 10) {
                sMonth = 6;
                sDay += 21;
            } else {
                sMonth = 7;
                sDay -= 9;
            }
            break;
        case 5:
        case 6:
        case 8:
            if (sDay < 10) {
                sMonth = 2;
                sDay += 22;
            } else {
                sMonth = 3;
                sDay -= 9;
            }
            break;
        case 7:
            if (sDay < 9) {
                sMonth = 9;
                sDay += 22;
            } else {
                sMonth = 10;
                sDay -= 8;
            }
            break;
        case 9:
            if (sDay < 10) {
                sMonth = 11;
                sDay += 21;
            } else {
                sMonth = 12;
                sDay -= 9;
            }
            break;
        case 10:
            if (sDay < 11) {
                sMonth = 12;
                sDay += 21;
            } else {
                sMonth = 1;
                sDay -= 10;
            }
            break;
        case 11:
            if (sDay < 12) {
                sMonth = 1;
                sDay += 20;
            } else {
                sMonth = 2;
                sDay -= 11;
            }
            break;
        case 12:
            if (sDay < 10) {
                sMonth = 2;
                sDay += 19;
            } else {
                sMonth = 3;
                sDay -= 9;
            }
            break;

        default:
            return;
    }

    var retDate = new Date(sYear, sMonth - 1, sDay); //در جاوا، ماه ها از صفر شروع می شوند
    var dateStr =
        sYear.toString() +
        "/" +
        sMonth.toString().padLeft(2, "0") +
        "/" +
        sDay.toString().padLeft(2, "0");
    return {
        Date: retDate,
        Year: sYear,
        Month: sMonth,
        Day: sDay,
        DateStr: dateStr,
    };
}
export const formattedDate = (serverTime) => {
    var timeStamp = serverTime;
    if (serverTime) {
        if (serverTime.toString().includes(")"))
            timeStamp = timeStamp.substring(
                serverTime.lastIndexOf("(") + 1,
                serverTime.lastIndexOf(")")
            );
        var dateTime = new Date(timeStamp);
        var gDateTime = new GregorianToSolar(
            dateTime.getFullYear(),
            dateTime.getMonth() + 1,
            dateTime.getDate()
        );
        var year = gDateTime.getFullYear();
        var month = gDateTime.getMonth();
        var date = gDateTime.getDate();
        var hour = dateTime.getHours();
        var min = dateTime.getMinutes();
        var sec = dateTime.getSeconds();

        var dateString = year + "/" + month + "/" + date;
        var timeString = hour + ":" + min + ":" + sec;
        return [dateString, timeString];
    }
};



